import { memo } from 'react';
import { useSelector } from 'react-redux';

import { type AssetCustomFieldValue } from '@air/api/types';

import { useCurrentClipPermissions } from '~/components/PrivateAssetModal/hooks/useCurrentClipPermissions';
import { centralizedClipAssetIdSelector } from '~/store/centralizedClip/selectors';
import { canChangeAssetCustomFields } from '~/utils/permissions/assetPermissions';
import { PrivateAssetCustomFieldPlainText } from './PrivateAssetCustomFieldPlainText';
import { PrivateAssetPanelCustomFieldContainer } from './PrivateAssetPanelCustomFieldContainer';

export type PrivateAssetPanelCustomFieldPlainTextProps = {
  field: AssetCustomFieldValue;
};

export const PrivateAssetPanelCustomFieldPlainText = memo(({ field }: PrivateAssetPanelCustomFieldPlainTextProps) => {
  const assetId = useSelector(centralizedClipAssetIdSelector);
  const { clipPermissions } = useCurrentClipPermissions();
  const canEditCustomFields = canChangeAssetCustomFields(clipPermissions);

  return (
    <PrivateAssetPanelCustomFieldContainer field={field}>
      <PrivateAssetCustomFieldPlainText
        field={field}
        trackingLocation="asset-details"
        canEditCustomFields={canEditCustomFields}
        assetId={assetId}
      />
    </PrivateAssetPanelCustomFieldContainer>
  );
});

PrivateAssetPanelCustomFieldPlainText.displayName = 'PrivateAssetPanelCustomFieldPlainText';
